export class CarrierInfoModel {
  name: string;
  surname: string;
  age: string;
  profilePicture: string;
  phone: string;
}


